/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/CustomerPages`).
 */

import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {shallowEqual, useSelector} from "react-redux";
import {Layout} from "../_metronic/layout";
import CustomerPages from "./navigation/CustomerPages";
import {AuthPage, Logout} from "./modules/Auth";
import AdminPages from "./navigation/AdminPages";

export function Routes() {
    const {isAuthorized, userType} = useSelector(
        ({auth}) => ({
            isAuthorized: auth.user != null,
            userType: auth.user != null && auth.user.level
        }),
        shallowEqual
    );

    return (
        <Switch>

            {!isAuthorized ? (
                /*Render auth page when user at `/auth` and not authorized.*/
                <Route>
                    <AuthPage/>
                </Route>
            ) : (
                /*Otherwise redirect to root page (`/`)*/
                <Redirect from="/auth" to="/"/>
            )}

            <Route path="/logout" component={Logout}/>

            {!isAuthorized ? (
                /*Redirect to `/auth` when user is not authorized*/
                <Redirect to="/auth/login"/>
            ) : (
                <Layout>
                    {userType === 1 && (
                        <AdminPages/>
                    )}
                    {userType === 0 && (
                        <CustomerPages/>
                    )}
                </Layout>
            )}
        </Switch>
    );
}
